'use client';
import cn from 'classnames';
import {
  type HTMLAttributes,
  type ReactNode,
  type RefObject,
  useRef,
  useState,
} from 'react';
import { useOnClickOutside } from 'usehooks-ts';

type Props = HTMLAttributes<HTMLDivElement> & {
  trigger: ReactNode;
  children: ReactNode;
};

export const Dropdown = ({
  trigger,
  children,
  className,
  ...divProps
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  const menuRef = useRef<HTMLUListElement>(null);
  useOnClickOutside(menuRef as RefObject<HTMLElement>, () => {
    setIsOpen(false);
  });

  return (
    <div
      {...divProps}
      className={cn({
        dropdown: true,
        'dropdown-open': isOpen,
        [className ?? '']: !!className,
      })}
    >
      <div onClick={() => setIsOpen(!isOpen)}>{trigger}</div>
      {isOpen && (
        <ul
          ref={menuRef}
          tabIndex={0}
          className="join join-vertical menu p-0 dropdown-content z-50 w-max rounded-lg bg-white shadow-md min-w-48"
        >
          {children}
        </ul>
      )}
    </div>
  );
};
